import { useLoad } from "@allergy123/api-client/react";
import { ApiError } from "@allergy123/api-client";
import { Button, Card, Status } from "@allergy123/ui";
import { learnUrl } from "../shell";

export function HomePage() {
  const data = useLoad((a) => a.reps.me());
  if (data.state === "error") {
    const forbidden = data.error instanceof ApiError && data.error.status === 403;
    return <Status kind={forbidden ? "info" : "error"} label={forbidden ? "This account isn't set up as a representative. Contact Allergy 123 support." : `Couldn't load your practices (${data.error?.message})`} />;
  }
  if (!data.data) return <p className="text-ink-secondary">Loading…</p>;
  const { representative, practices, training } = data.data;
  return (
    <>
      <h1 className="mb-2 text-h1 font-semibold text-anchor">My practices</h1>
      <p className="mb-8 max-w-[68ch] text-ink-secondary">
        Representative {representative.code} · {representative.status}. The practices assigned to you, their monthly activity as counts, and your commission statements. Nothing here includes patient information.
      </p>
      <div className="grid gap-6 md:grid-cols-[2fr_1fr]">
        <Card as="section">
          <h2 className="mb-4 text-h3 font-semibold text-anchor">Assigned practices</h2>
          {practices.length === 0 ? (
            <p className="text-ink-secondary">No practices assigned yet.</p>
          ) : (
            <ul className="divide-y divide-rule-subtle">
              {practices.map((p) => (
                <li key={p.organizationId} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-baseline sm:justify-between">
                  <span className="font-medium">{p.name}</span>
                  <span className="text-small text-ink-secondary">
                    since {p.startsOn}
                    {p.endsOn ? ` · until ${p.endsOn}` : ""}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </Card>
        <Card as="section" tone="tinted">
          <h2 className="mb-2 text-h3 font-semibold text-anchor">Representative training</h2>
          <p className="mb-4 text-small">{training.entitled ? "Your training lives in Allergy 123 Learning under your representative entitlement." : "Your account has no training entitlement yet; ask Allergy 123 to add it."}</p>
          <Button href={learnUrl} disabled={!training.entitled}>
            Go to training
          </Button>
        </Card>
      </div>
    </>
  );
}
